var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-container",attrs:{"id":"PrintArea"}},_vm._l((_vm.pdfDocumentPages),function(page){return _c('div',{key:`page${page}`,attrs:{"id":`Page${page}`}},[_c('canvas',{staticClass:"print el-canvas",attrs:{"id":`the_canvas${page}`}}),_c('div',{staticClass:"annotationLayer",attrs:{"id":`annotationLayer${page}`}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }